import Vue from 'vue'
import Router from 'vue-router'
import login from '../views/login.vue'
import store from '@/store'
import bus from '@/utils/bus'


Vue.use(Router)

const constantRoutes = [
  {
    path: '/',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      keepAlive: true,
    },
    component: () => import('../views/register.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      keepAlive: true,
    },
    component: () => import('../views/home.vue')
  },
  {
    path: '/modifyPassword',
    name: 'modifyPassword',
    meta: {
      title: '修改密码',
      keepAlive: true,
    },
    component: () => import('../views/modifyPassword')
  },
  {
    path: '/modifyAll',
    name: 'modifyAll',
    meta: {
      title: '密码重置',
      keepAlive: true,
    },
    component: () => import('../views/modifyAll')
  }
  
]

const router = new Router({
  mode: 'hash',
  routes: constantRoutes,
})
router.beforeEach((to, from, next) => {
  next()
  
});

router.afterEach((to, from) => {
  // bus.$emit("routerLinke", to.path !== '/PaymentDetalis' && to.path !== '/orderList' && to.path !== '/PaymentCallback' ? false : true);
  return true
})

export default router
